import { Helmet } from "react-helmet";
import {
  Autocomplete,
  Box,
  Button,
  Container,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  Menu,
  MenuItem,
  Paper,
  Select,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Toolbar,
  Typography,
  FormHelperText,
} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useTranslation } from "react-i18next";
import { makeStyles, withStyles } from "@mui/styles";
import React, { useEffect } from "react";
import cssVariables from "../../theme/cssVariables";
import portfolioService from "../../services/workloadAndPerformance.service";

const useStyles = makeStyles({
  "error": {
    color: " #CC6058 !important",
    position: "relative",
    marginBottom: "14px !important",
    "& div > p": {
      color: " #CC6058 !important",
      fontSize: "14px",
      lineHeight: "15.4px",
      marginLeft: 0,
      position: "absolute",
      bottom: "-22px",
    },
    "& > p": {
      color: " #CC6058 !important",
      fontSize: "14px",
      lineHeight: "15.4px",
      marginLeft: 0,
      position: "absolute",
      bottom: "-22px",
    }
  },
  "errorDis": {
    color: " #CC6058 !important",
    position: "relative",
    marginBottom: "14px !important",
    "&  > div > div ": {
      backgroundColor: "#F5F5F5 !important",
    },
    "& div > p": {
      color: " #CC6058 !important",
      fontSize: "14px",
      lineHeight: "15.4px",
      marginLeft: 0,
      position: "absolute",
      bottom: "-22px",
    },
    "& > p": {
      color: " #CC6058 !important",
      fontSize: "14px",
      lineHeight: "15.4px",
      marginLeft: 0,
      position: "absolute",
      bottom: "-22px",
    }
  },
  "autocomplete-root": {
    backgroundColor: `${cssVariables.color.primary}!important`,
    borderRadius: '4px!important',
    color: '#fff!important',
  },
  "autocomplete-remove-icon": {
    fontSize: '1.2rem!important',
    lineHeight: 1.5
  },
  footer: {
    position: "sticky",
    bottom: "-20px",
    background: "white",
    paddingTop: "20px",
    paddingBottom: "15px",
  }
});

const CustomAutocomplete = withStyles({
  clearIndicator: {
    backgroundColor: 'unset!important',
    textDecoration: 'underline!important',
    '&:hover': {
      color: 'rgba(0, 0, 0, 0.8)'
    }
  }
})(Autocomplete);

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const validationSchema = yup.object({
  name: yup.string().max(250, "ความยาวไม่เกิน 250 ตัวอักษร").required("กรุณาระบุข้อมูล ชื่อภาระงานและผลงาน"),
  workTypeSelected: yup.string().required("กรุณาระบุประเภทภาระงานและผลงาน"),
  subWorkTypeSelected: yup.string().required("กรุณาระบุประเภทภาระงานและผลงานย่อย")
});

const DefaultForm = (props) => {
  const [lists, setLists] = React.useState([]);
  const [listsSub, setListsSub] = React.useState([]);
  const [serial, setSerial] = React.useState("");
  const [workTypeSelected, setValueWorkType] = React.useState("");
  const [subWorkTypeSelected, setValueSubWorkType] = React.useState("");
  const [initialValues, setInitialValues] = React.useState({});

  const formik = useFormik({
    initialValues: {
      name: props.data.name,
      description: props.data.description,
      workTypeSelected: props.data.rb_work_category,
      subWorkTypeSelected: props.data.rb_work_condition,
      subTitle: ""
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      props.submit(values)
    },
  });

  const selectWorkType =async (event) => {
    // setValueWorkType(event.target.value);
    // formik.values.workTypeSelected = event.target.value
    await formik.setFieldValue("workTypeSelected", event.target.value)
    await formik.setFieldValue("subWorkTypeSelected", "")
  };
  const selectWorkSerial = async (serial, data) => {
    setListsSub(data)
    await formik.setFieldValue("workTypeSelected", serial)
    await formik.setFieldValue("subWorkTypeSelected", "")
  };
  const selectSubWorkType =async (data, name) => {
    // setValueSubWorkType(event.target.value);
    await formik.setFieldValue("subWorkTypeSelected", data)
    await formik.setFieldValue("subTitle", name)
  };
  const handleSubmit = () => {
    formik.submitForm()
  }
  useEffect(() => {
    getCategorys()
  }, []);

  const formatData = (data, defaults) => {
    if (data !== null && data !== undefined && data !== "") {
      return data;
    }
    return defaults;
  }

  const dis = (data) => {
    if (props.item.id !== undefined && props.item.id !== null && props.item.id !== "") {
      if (props.item.isManual !== undefined && props.item.isManual !== null && props.item.isManual !== "") {
        if (props.item.isManual === true) {
          if (data === "tpye") {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      } else {
        return false
      }
    }
    return false
  }

  const code = (data) => {
    let text = ""
    if (data !== undefined && data !== null && data !== "" && data !== "other") {
      text = data + "- "
    }
    return text
  }

  const getCategorys = () => {
    if (props.item.id !== undefined && props.item.id !== null && props.item.id !== "") {
      portfolioService.getCategory(props.item.id).then(
        (response) => {
          setLists(response.data);
          formik.setFieldValue("name", formatData(response?.value?.name, ""))
          formik.setFieldValue("description", formatData(response?.value?.description, ""))
          formik.setFieldValue("workTypeSelected", formatData(response?.value?.rb_work_category?.serial, ""))
          formik.setFieldValue("subWorkTypeSelected", formatData(response?.value?.rb_work_condition?.serial, ""))

          let selecedata = response?.data.find((res) => res.rb_work_category?.serial === response?.value?.rb_work_category?.serial)
          let name = selecedata.rb_work_condition.find((res) => res?.serial === response?.value?.rb_work_condition?.serial)
          setListsSub(selecedata.rb_work_condition)
          formik.setFieldValue("subTitle", code(name?.code)+name?.name)
        },
      );
    } else {
      portfolioService.getCategory().then(
        (response) => {
          setLists(response.data);
          if (props.data.rb_work_category !== "" && props.data.rb_work_category !== null && props.data.rb_work_category !== undefined) {
            let selecedata = response.data.find((res) => res.rb_work_category?.serial === props.data.rb_work_category)
            setListsSub(selecedata.rb_work_condition)
          }
        },
      );
    }
  }
  const classes = useStyles();
  const styles = {
    link: {
      color: "#5DA196",
      fontWeight: 300
    }
  }
  return (
    <Box sx={{ padding: "24px 24px 0 24px" }}>
      <Grid container>
        <Grid item xs sx={{ display: "flex", justifyContent: "center" }}>
          <Typography variant="h3">{props.item.id !== undefined && props.item.id !== null && props.item.id !== "" ? "แก้ไข" : "เพิ่ม"}ภาระงานและผลงาน <span style={styles.link}>(1/2)</span></Typography>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs>
          <Typography variant="h4">รายละเอียดภาระและผลงาน</Typography>
        </Grid>
      </Grid>
      <Grid container mt={2}>
        <Grid item>
          <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">ชื่อภาระงานและผลงาน<Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs classes={{ root: dis() === false ? classes["error"] : classes["errorDis"] }}>
          <TextField
            margin="dense"
            id="name"
            fullWidth
            sx={{ marginTop: "10px", marginBottom: 0 }}
            size="small"
            value={formik.values.name}
            placeholder="กรอกชื่อภาระงานและผลงาน"
            onChange={formik.handleChange}
            helperText={formik.touched.name && formik.errors.name}
            error={Boolean(formik.touched.name && formik.errors.name)}
            disabled={dis()}
          />
        </Grid>
      </Grid>
      <Grid container mt={2}>
        <Grid item>
          <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">รายละเอียด</Typography>
        </Grid>
      </Grid>
      <Grid container >
        <Grid item xs classes={{ root: dis() === false ? classes["error"] : classes["errorDis"] }}>
          <TextField
            multiline
            rows={4}
            margin="dense"
            id="description"
            type="email"
            fullWidth
            sx={{ marginTop: "10px", marginBottom: 0 }}
            placeholder="กรอกรายละเอียด"
            size="small"
            value={formik.values.description}
            onChange={formik.handleChange}
            helperText={formik.touched.description && formik.errors.description}
            error={Boolean(formik.touched.description && formik.errors.description)}
            disabled={dis()}
          />
        </Grid>
      </Grid>
      <Grid container mt={2}>
        <Grid item>
          <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">ประเภทภาระงานและผลงาน<Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
        </Grid>
      </Grid>
      <Grid container >
        <Grid item xs classes={{ root: dis("tpye") === false ? classes["error"] : classes["errorDis"] }}>
          <Select
            id="work-type-select"
            variant="outlined"
            defaultValue=""
            displayEmpty
            size="small"
            fullWidth
            className="white-bg"
            value={formik.values.workTypeSelected}
            sx={Boolean(formik.touched.workTypeSelected && formik.errors.workTypeSelected) ? { border: "0.5px solid red", marginTop: "10px", marginBottom: 0 } : { marginTop: "10px", marginBottom: 0 }}
            disabled={dis("tpye")}
          >
            <MenuItem disabled value="">
              <Typography variant="sub_label" style={{ fontWeight: "300" }}>เลือกประเภทภาระงานและผลงาน</Typography>
            </MenuItem>
            {
              lists?.length > 0 ?
                lists.map(item => {
                  return (
                    <MenuItem value={item.rb_work_category.serial} key={item.rb_work_category.name} onClick={() => selectWorkSerial(item.rb_work_category.serial, item.rb_work_condition)}>
                      {item.rb_work_category.name}
                    </MenuItem>
                  )
                })
                : <MenuItem value="">
                  ไม่พบข้อมูล
                </MenuItem>
            }
          </Select>
          {formik.touched.workTypeSelected && formik.errors.workTypeSelected ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.workTypeSelected} </FormHelperText>) : <></>}
        </Grid>
      </Grid>
      <Grid container mt={2}>
        <Grid item>
          <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">ประเภทภาระงานและผลงานย่อย<Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs classes={{ root: dis("tpye") === false ? classes["error"] : classes["errorDis"] }}>
          <Select
            id="work-type-select"
            variant="outlined"
            defaultValue=""
            displayEmpty
            size="small"
            fullWidth
            className="white-bg"
            value={formik.values.subWorkTypeSelected}
            sx={Boolean(formik.touched.subWorkTypeSelected && formik.errors.subWorkTypeSelected) ? { border: "0.5px solid red", marginTop: "10px", marginBottom: 0 } : { marginTop: "10px", marginBottom: 0 }}
            disabled={dis("tpye")}
          >
            <MenuItem disabled value="">
              <Typography variant="sub_label" style={{ fontWeight: "300" }}>เลือกประเภทภาระงานและผลงานย่อย</Typography>
            </MenuItem>
            {
              listsSub?.length > 0 ?
                listsSub.map(item => {
                  return (
                    <MenuItem value={item.serial} key={item.name} onClick={() => selectSubWorkType(item.serial, code(item.code) + item.name)}>
                      {code(item.code)}{item.name}
                    </MenuItem>
                  )
                })
                : null
            }
          </Select>
          {formik.touched.subWorkTypeSelected && formik.errors.subWorkTypeSelected ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.subWorkTypeSelected} </FormHelperText>) : <></>}
          {/* <CustomAutocomplete
              multiple
              id="checkboxes-tags-demo"
              value={subWorkTypeSelected}
              onChange={selectSubWorkType}
              clearIcon={
                (
                  <Typography fontSize={12}>ล้างทั้งหมด</Typography>
                )
              }
              isOptionEqualToValue= {(option, value) => option.value == value.value }
              options={listsSub}
              disableCloseOnSelect
              getOptionLabel={(option) => option.title}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.title}
                </li>
              )}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <React.Fragment>
                    <Chip
                      {...getTagProps({ index })}
                      key={option.title}
                      label={option.title}
                      color="primary"
                      variant="fill"
                      classes={{ root: classes["autocomplete-root"] }}
                      deleteIcon={
                        ( 
                          <Box className={classes["autocomplete-remove-icon"]}>x</Box> 
                        )
                      }
                    />
                  </React.Fragment>
                ))
              }
              renderInput={(params) => {
                return (
                  <TextField
                    {...params}
                    placeholder={ subWorkTypeSelected.length < 1 ? "เลือกประเภทภาระงานและผลงานย่อย" : "" }
                  />
                )
                }
              }
            /> */}
        </Grid>
      </Grid>
      <Grid container mt={3} mb={0} classes={{ root: classes.footer }}>
        <Grid item xs display="flex" flexDirection="row-reverse">
          <Box sx={{ width: "100px" }}>
            <Button onClick={handleSubmit} color="primary" variant="contained" fullWidth>
              ถัดไป
            </Button>
          </Box>
          <Box mr={2} sx={{ width: "100px" }}>
            <Button onClick={props.close} color="black" variant="outlined" fullWidth>
              ยกเลิก
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
export default DefaultForm;
